// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import cacke from '../img/cacke.jpeg';
// import anni from '../img/anni.jpg';
// import { FaWhatsapp } from 'react-icons/fa';
// import Llogo from '../img/Llogo.png';
// import { ArrowLeftOutlined } from '@ant-design/icons';
// import { useNavigate } from 'react-router-dom';


// const BamaWeb = () => {
//   const [BamaData, setBamaData] = useState([]);
//   const [BamaDataMA, setBamaDataMA] = useState([]);
//   const dist = sessionStorage.getItem("dist");
//     const navigate = useNavigate();

//   const getTodayDate = () => {
//     const date = new Date();
//     const day = String(date.getDate()).padStart(2, '0');
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     return `${day}-${month}`;
//   };

  // const fetchBamaData = async () => {
  //   const today = getTodayDate();
  //   const [baRes, maRes] = await Promise.all([
  //     axios.post('https://lionsdirectoryapi.emedha.in/get/bama/BA', {
  //       getBA: today,
  //       dist
  //     }),
  //     axios.post('https://lionsdirectoryapi.emedha.in/get/bama/MA', {
  //       getMA: today,
  //       dist
  //     })
  //   ]);
  //   setBamaData(baRes.data);
  //   setBamaDataMA(maRes.data);
  // };

//   useEffect(() => {
//     fetchBamaData();
//   }, []);

//   const formatDayMonth = (dateString) => {
//     if (!dateString) return '';
//     const parts = dateString.includes('-') ? dateString.split('-') : dateString.split('/');
//     const [d, m] = dateString.includes('-') ? [parts[0], parts[1]] : [parts[1], parts[0]];
//     const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
//     return `${d.padStart(2, '0')}-${monthNames[parseInt(m, 10) - 1]}`;
//   };

//   const renderCard = (bama, type) => (
//     <div key={bama.memberId} style={{
//       marginTop: 10,
//       backgroundColor: type === 'BA' ? 'rgb(241, 202, 130)' : 'rgb(98, 152, 223)',
//       borderRadius: 4,
//       margin: '10px 4px',
//       boxShadow: '0 0 10px rgba(0,0,0,0.2)'
//     }}>
//              <div style={{
//               backgroundColor: '#fff',
//               padding: '15px',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'space-between'
//             }}>

//             </div>
//       <div style={{ textAlign: 'center', padding: '10px' }}>
//         <img
//   src={bama.photo ? bama.photo : Llogo}
//   alt="profile"
//   style={{
//     height: 100,
//     width: 100,
//     borderRadius: '50%',
//     border: '2px solid #ccc',
//     objectFit: 'cover'
//   }}
// />

//       </div>
//       <div style={{ backgroundColor: type === 'BA' ? 'rgb(241, 166, 26)' : 'rgb(14, 57, 114)', color: 'white', padding: '10px', borderTopLeftRadius: 4, borderTopRightRadius: 4 }}>
//         <p>{bama.membershipNo}</p>
//         <p>{bama.clubs}</p>
//         <p>{bama.membershipName}</p>
//         <p>{bama.mobile}</p>
//         <p>{bama.email}</p>
//         <p>{type}: {formatDayMonth(type === 'BA' ? bama.birthAnniversary : bama.marriageAnniversary)}</p>
//       </div>
//       <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px', backgroundColor: '#fff', borderBottomLeftRadius: 4, borderBottomRightRadius: 4 }}>
//         <span style={{ color: type === 'BA' ? 'orange' : 'rgb(14, 57, 114)', fontWeight: 'bold', fontSize: '16px' }}>{bama.membershipName}</span>
//         <div style={{ display: 'flex', gap: '10px' }}>
//       <img src={type === 'BA' ? cacke : anni} alt="icon" style={{ height: 38, width: 38, borderRadius: 10 }} />

//           <a
//             href={`https://api.whatsapp.com/send?phone=+91${bama.mobile}&text=🎂 Happy ${type === 'BA' ? 'Birth' : 'Marriage'} Day dear 🎀 ${bama.membershipName}`}
//             target="_blank"
//             rel="noopener noreferrer"
//             style={{ height: 40, width: 40, borderRadius: 20, backgroundColor: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//            <FaWhatsapp style={{ color: 'green', fontSize: '30px' }} />
//           </a>
//         </div>
//       </div>
//     </div>
//   );

//   return (
//     <div style={{
//       width: '365px',
//       minHeight: '557px',
//       maxHeight: '667px',
//       margin: '10px auto',
//       border: '1px solid #ccc',
//       borderRadius: '20px',
//       overflowY: 'scroll',
//       boxShadow: '0 0 10px rgba(0,0,0,0.2)',
//       backgroundColor: '#f8f9fa',
//       padding: '10px'
//     }}>
//                    <div style={{ display: 'flex', alignItems: 'center' }}>
//                 <ArrowLeftOutlined
//                   style={{
//                     fontSize: '18px',
//                     color: '#0e3972',
//                     cursor: 'pointer',
//                     marginRight: '10px'
//                   }}
//                   onClick={() => navigate('/home')} // or the correct route for HomeScreen
//                 />
//                 <h6 style={{ color: '#0e3972', fontWeight: 'bold', margin: 0 }}>Birth&Merriage Anniversary</h6>
//               </div>
        
//       <h3 style={{ backgroundColor: 'rgb(241, 202, 130)', color: 'rgb(14, 57, 114)', textAlign: 'center', padding: 10, borderRadius: 4 ,marginTop: 20}}>Birth Anniversary</h3>
//       {BamaData.map(bama => renderCard(bama, 'BA'))}

//       <h3 style={{ backgroundColor: 'rgb(14, 57, 114)', color: 'white', textAlign: 'center', padding: 10, borderRadius: 4 }}>Marriage Anniversary</h3>
//       {BamaDataMA.map(bama => renderCard(bama, 'MA'))}
//     </div>
//   );
// };

// export default BamaWeb;
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ChevronLeft, Calendar, Phone, MessageCircle } from 'lucide-react';

const BAMAList = ({ onBack, styles }) => {

  const [activeTab, setActiveTab] = useState('BIRTH');
  const [members, setMembers] = useState([]);
  const [selectedDate] = useState(new Date()); // Today

    const districtCode = sessionStorage.getItem("dist");

  // Format date as DD-MM
  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    return `${day}-${month}`;
  };

  const displayDate = selectedDate.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long'
  });

  useEffect(() => {
    fetchBAMA();
  }, [activeTab]);


  const [wishes, setWishes] = useState({});

const getWishes = async () => {
  try {
    const res = await axios.get(
      "https://lionsdirectoryapi.emedha.in/get-wishes"
    );

    const wishObj = {};
    res.data.forEach((w) => {
      wishObj[w.type] = w.message;   // BA / MA
    });

    setWishes(wishObj);

  } catch (error) {
    console.log(error);
  }
};

useEffect(() => {
  getWishes();
}, []);


const sendWhatsAppWish = (item) => {

  const message =
    activeTab === 'BIRTH'
      ? `🎂 ${wishes.BA || ''} 🎀 ${item.membershipName}`
      : `💍 ${wishes.MA || ''} 💐 ${item.membershipName}`;

  const encodedMessage = encodeURIComponent(message);

  const phone = item.mobile?.replace(/\D/g, ''); // remove spaces etc

  window.open(
    `https://api.whatsapp.com/send?phone=91${phone}&text=${encodedMessage}`,
    "_blank"
  );
};

  const fetchBAMA = async () => {
    try {
      const formattedDate = formatDate(selectedDate);

      const url =
        activeTab === 'BIRTH'
          ? 'https://lionsdirectoryapi.emedha.in/get/bama/BA'
          : 'https://lionsdirectoryapi.emedha.in/get/bama/MA';

      const body =
        activeTab === 'BIRTH'
          ? { getBA: formattedDate, dist: districtCode }
          : { getMA: formattedDate, dist: districtCode };

      const res = await axios.post(url, body);
      setMembers(res.data);

    } catch (error) {
      console.log(error);
    }
  };

  const formatDisplayDate = (dateString) => {
  if (!dateString) return '';

  const [day, month] = dateString.split('-'); // ignore year
  const date = new Date(2025, parseInt(month) - 1, parseInt(day));

  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short'
  });
};

  return (
    <div style={styles.scrollArea}>
      {/* Header */}
      <div style={{ backgroundColor: '#0033A0', color: 'white', padding: '15px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
            <ChevronLeft onClick={onBack} style={{ cursor: 'pointer' }} size={24} />
            <h2 style={{ fontSize: '18px', margin: 0 }}>
              BAMA – {displayDate}
            </h2>
          </div>
          <Calendar size={20} />
        </div>

        {/* Toggle */}
        <div style={{
          display: 'flex',
          backgroundColor: '#1E4DB7',
          borderRadius: '25px',
          marginTop: '15px',
          padding: '4px'
        }}>
          <button
            onClick={() => setActiveTab('BIRTH')}
            style={{
              flex: 1,
              padding: '10px',
              borderRadius: '20px',
              border: 'none',
              fontWeight: 'bold',
              backgroundColor: activeTab === 'BIRTH' ? '#FFC20E' : 'transparent',
              color: activeTab === 'BIRTH' ? '#333' : 'white',
              cursor: 'pointer'
            }}
          >
            Birth Anniversary
          </button>

          <button
            onClick={() => setActiveTab('MARRIAGE')}
            style={{
              flex: 1,
              padding: '10px',
              borderRadius: '20px',
              border: 'none',
              fontWeight: 'bold',
              backgroundColor: activeTab === 'MARRIAGE' ? '#FFC20E' : 'transparent',
              color: activeTab === 'MARRIAGE' ? '#333' : 'white',
              cursor: 'pointer'
            }}
          >
            Marriage Anniversary
          </button>
        </div>
      </div>

      {/* List */}
      <div style={{ padding: '15px' }}>

        {members.map((item, index) => (
          <div key={index} style={{
            backgroundColor: 'white',
            borderRadius: '15px',
            padding: '15px',
            marginBottom: '15px',
            border: '1px solid #eee',
            boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
          }}>

            <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>

              {/* Avatar */}
              <div style={{
                width: '50px',
                height: '50px',
                borderRadius: '50%',
                backgroundColor: '#0033A0',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                fontSize: '18px',
                fontWeight: 'bold',
                color: 'white'
              }}>
                {item.membershipName?.charAt(0)}
              </div>

              {/* Info */}
              <div style={{ flex: 1 }}>
                <h3 style={{ margin: 0, fontSize: '13px' }}>{item.membershipName}</h3>
                <div style={{ fontSize: '16px', color: '#666' }}>
                  {item.clubs}
                </div>
                <div style={{ fontSize: '12px', color: '#999' }}>
                  ID: {item.membershipNo}
                </div>
              </div>

              {/* Actions */}
              <div style={{ display: 'flex', gap: '8px' }}>
               <div
  onClick={() => sendWhatsAppWish(item)}
  style={{ cursor: 'pointer' }}
>
  <MessageCircle size={18} color="#25D366" />
</div>
                <a href={`tel:${item.mobile}`}>
                  <Phone size={18} color="#0033A0" />
                </a>
              </div>
            </div>

            {/* Badge */}
            <div style={{ marginTop: '10px', textAlign: 'right' }}>
              <div style={{
                backgroundColor: activeTab === 'BIRTH' ? '#FFF8E1' : '#E8EEFB',
                padding: '5px 12px',
                borderRadius: '15px',
                display: 'inline-block',
                fontSize: '12px',
                fontWeight: 'bold'
              }}>
               {activeTab === 'BIRTH'
  ? `🎂 BA: ${formatDisplayDate(item.birthAnniversary)}`
  : `💍 MA: ${formatDisplayDate(item.marriageAnniversary)}`}
              </div>
            </div>

          </div>
        ))}

        {/* Summary */}
        <div style={{
          textAlign: 'center',
          padding: '15px',
          backgroundColor: 'white',
          borderRadius: '10px',
          border: '1px solid #eee'
        }}>
          <strong>{members.length}</strong> {activeTab === 'BIRTH'
            ? 'Birth Anniversaries'
            : 'Marriage Anniversaries'} on {displayDate}
        </div>

      </div>
    </div>
  );
};

export default BAMAList;